const states = [
    { id: 'no asignado', name: 'no asignado' },
    { id: 'asignado', name: 'asignado' },
    { id: 'terapia culminada', name: 'terapia culminada' },
    { id: 'aceptado', name: 'aceptado' },
]

export default states;
